import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Form } from "../models/form";
import { AppHttpClient } from './http.client';

@Injectable({
  providedIn: "root",
})
export class FormsService {
  constructor(private http: AppHttpClient) { }

  get(formId: string): Observable<Form> {
    return this.http.get<Form>(`forms/${formId}`);
  }

  delete(formId: string): Observable<boolean> {
    return this.http.delete<boolean>(
      `forms?id=${formId}`
    );
  }

  unpublish(formId: string): Observable<boolean> {
    return this.http.put<boolean>(
      `forms/unpublish?formId=${formId}`,
      {}
    );
  }

  getByCode(
    formCode: string,
    status: string = "Published"
  ): Observable<Form> {
    return this.http.get<Form>(
      `forms/by-code/${formCode}?status=${status}`
    );
  }

  list(): Observable<Form[]> {
    return this.http.get<Form[]>(`forms/list`);
  }

  getWorkflow(formId: string): Observable<Form> {
    return this.http.get<Form>(`forms/${formId}`);
  }

  create(form: Form): Observable<Form> {
    return this.http.post<Form>(`forms`, form);
  }

  createWithColumns(data: any): Observable<Form> {
    return this.http.post<Form>(
      `forms/insert-with-columns`,
      data
    );
  }

  updateCustom(form: Form): Observable<Form> {
    return this.http.put<Form>(
      `forms/update-custom`,
      form
    );
  }

  updateWithColumns(data: any): Observable<Form> {
    return this.http.put<Form>(
      `forms/update-with-columns`,
      data
    );
  }

  publish(formCode: string, formStatus: string): Observable<Form> {
    return this.http.post<Form>(
      `forms/publish/${formCode}?status=${formStatus}`,
      {}
    );
  }

  clone(formId: string): Observable<Form> {
    return this.http.post<Form>(
      `forms/clone?formId=${formId}`,
      {}
    );
  }

  restore(id: string): Observable<Form> {
    return this.http.post<Form>(`forms/restore?id=${id}`, {});
  }
}
